import {
  MAKE_REQUEST,
  FAIL_REQUEST,
  GET_ACTION_LIST,
  UPDATE_FETCH_ACTION_LIST_STATUS,
  SET_REQUEST_FOR_REASSIGN,
  SET_SINGLE_ACTION_DETAILS,
  SET_UPDATE_IS_COMPLETE_RESPONSE,
  SET_ACTION_ACTIVITIES_DETAILS,
  UPDATE_ISSUCCESS,
  SET_CANCEL_ACTION_RESPONSE,
  SET_ACTION_LIST_FOR_CHART,
  SET_USER_TOTAL_DUE_ACTION_PRIORITY_WISE,
  MAKE_UPDATE_REQUEST,
  SET_SUCCESS,
  SET_ACTION_DATA,
  SET_MEETING_CHART,
  SET_ATTENDEE_CHART,
  SET_MEETING_CHART_AND_ATTENDEE_CHART,
  CARD_CLICK_TYPE,
  SET_HIDE_MY_TASK_BUTTON,
  CHART_CLICK_TYPE,
  RE_ASSIGN_TYPE,
  SET_ISCHECKED_REQUIRED,
  FILTER_CLICK
} from "../actions/actionAction/actionTypes";

const initialObject = {
  loading: false,
  updateLoading: false,
  singleActionDetails: null,
  message: "",
  totalCount: 0,
  isSuccess: false,
  hasFetched: false, // 👈 new
  actionList: [],
  isFetchedActionList: false,
  statusData: [
    "PENDING",
    "REQUESTFORREASSIGN",
    "REASSIGNED",
    "COMPLETED",
    "REOPENED",
    "APPROVED",
    "CANCELLED",
  ],
  actionActivitiesDetails: [],
  totalActionList: [],
  userDueActionDetailsPriorityWise: [],
  lastCardClickType: null,
  hidemyTaskButton: false,
  chartpage: false,
  reassignType: false,
  isCheckRequired: false,
isFilterclick:false
};

export const actionReducer = (state = initialObject, action) => {
  switch (action.type) {
    case MAKE_REQUEST:
      return {
        ...state,
        loading: true,
        hasFetched: false,
      };
    case FAIL_REQUEST:
      return {
        ...state,
        loading: false,
        hasFetched: true,
      };
    case SET_SUCCESS:
      return {
        ...state,
        isSuccess: action.payload,
      };

    case MAKE_UPDATE_REQUEST:
      return {
        ...state,
        updateLoading: action.payload,
      };
    case UPDATE_ISSUCCESS:
      return {
        ...state,
        isSuccess: action.payload,
        loading: false,
      };
    case GET_ACTION_LIST:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        actionList: action.payload.data?.actionDatas
          ? action.payload.data?.actionDatas
          : [],
        totalCount: action.payload.data?.totalCount,
        isSuccess: action.payload.success,
        isFetchedActionList: false,
      };
    case UPDATE_FETCH_ACTION_LIST_STATUS:
      return {
        ...state,
        isFetchedActionList: action.payload,
      };

    case SET_REQUEST_FOR_REASSIGN:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        isSuccess: action.payload.success,
      };
    case SET_SINGLE_ACTION_DETAILS:
      return {
        ...state,
        loading: false,
        hasFetched: true,
        singleActionDetails: action.payload.data,
      };

    case SET_UPDATE_IS_COMPLETE_RESPONSE:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        isSuccess: action.payload.success,
      };
    case SET_ACTION_ACTIVITIES_DETAILS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        isSuccess: action.payload.success,
        actionActivitiesDetails: action.payload?.data
          ? action.payload?.data
          : [],
      };
    case SET_CANCEL_ACTION_RESPONSE:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        isSuccess: action.payload.success,
      };
    case SET_ACTION_LIST_FOR_CHART:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        isSuccess: action.payload.success,
        totalActionList: action.payload.data,
      };
    case SET_USER_TOTAL_DUE_ACTION_PRIORITY_WISE:
      return {
        ...state,
        userDueActionDetailsPriorityWise: action.payload.data,
      };
    case SET_ACTION_DATA:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        actionList: action.payload?.actionDatas,
        totalCount: action.payload?.totalCount,
        loading: false,
        // isSuccess: action.payload.success
      };
    case SET_ATTENDEE_CHART:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        isAttendeeChartOpened: action.payload?.status,
        isMeetingChartOpened: false,
        assignedUserId: action?.payload?.assignedUserId,
        clickedMeetingId: null,
      };
    case SET_MEETING_CHART:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        isMeetingChartOpened: action.payload.status,
        clickedMeetingId: action?.payload?.clickedMeetingId,
        isAttendeeChartOpened: false,
        assignedUserId: null,
        // page:1,
      };

    case SET_MEETING_CHART_AND_ATTENDEE_CHART:
      console.log("Reducer Payload (Full API Response):", action);
      return {
        ...state,
        isMeetingChartOpened: false,
        clickedMeetingId: false,
        isAttendeeChartOpened: false,
        assignedUserId: null,
      };
    case CARD_CLICK_TYPE:
      console.log("Reducer Payload (CARD_CLICK_TYPE)22:", action);
      return {
        ...state,
        lastCardClickType: action.payload,
      };
    case SET_HIDE_MY_TASK_BUTTON:
      console.log("Reducer Payload (CARD_CLICK_TYPE):", action);
      return {
        ...state,
        hidemyTaskButton: action.payload,
      };
    case CHART_CLICK_TYPE:
      console.log("Reducer Payload (CARD_CLICK_TYPE):", action);
      return {
        ...state,
        chartpage: action.payload,
      };
    case RE_ASSIGN_TYPE:
      console.log("Reducer Payload (CARD_CLICK_TYPE):", action);
      return {
        ...state,
        reassignType: action.payload,
      };
    case SET_ISCHECKED_REQUIRED:
      return {
        ...state,
        isCheckRequired: action.payload,
      };
       case FILTER_CLICK:
      return {
        ...state,
        isFilterclick: action.payload,
      };
    default:
      return state;
  }
};
